import './styles.scss'

import React from 'react'
import { connect } from 'kea'

import dropPinIcon from '../_assets/drop-pin-icon.svg'
import webcamIcon from '../_assets/webcam-icon.svg'

import courseLogic from '~/scenes/course/show/logic'

export default connect({
  actions: [courseLogic, ['setHoverLocation']],
  props: [courseLogic, ['course', 'hoverLocation']]
})(({ course: { locations }, actions: { setHoverLocation }, onClick }) => {
  const processLocations = data => {
    const groupedLocationsByType = {}

    data.forEach(item => {
      if (!groupedLocationsByType[item.locationType]) {
        groupedLocationsByType[item.locationType] = {
          locationType: item.locationType,
          locationTypeLabel: item.locationTypeLabel,
          locations: []
        }
      }

      if (item.location) {
        groupedLocationsByType[item.locationType].locations.push({
          id: item.id,
          location: item.location,
          latitude: item.latitude,
          longitude: item.longitude,
          radius: item.radius
        })
      }
    })

    const GroupedByTypeLocations = Object.values(groupedLocationsByType).map(group => {
      const result = {
        locationType: group.locationType,
        locationTypeLabel: group.locationTypeLabel
      }

      if (group.locationType !== 'webcam') {
        result.locations = group.locations
      }

      return result
    })

    const typeOrder = { in_house: 1, in_studio: 2, webcam: 3 }

    GroupedByTypeLocations.sort(
      (firstLocation, secondLocation) => typeOrder[firstLocation.locationType] - typeOrder[secondLocation.locationType]
    )

    return GroupedByTypeLocations
  }

  const transformedLocations = processLocations(locations)

  const hasOnlyOneLocationType = transformedLocations.length === 1

  const noWebcam = transformedLocations.every(location => location.locationType !== 'webcam')

  return (
    <div className='locations-list'>
      {transformedLocations.map((location, index) => (
        <div
          key={index}
          className={`location-section${location.locationType !== 'webcam' ? ' house-studio' : ''}${
            noWebcam ? ' no-webcam-in-all-location-types' : ''
          }${hasOnlyOneLocationType ? ' only-one-location-type' : ''}`}
        >
          <div className={`location-title-container${location.locationType !== 'in_house' ? ' with-padding' : ''}`}>
            <div className='location-icon'>
              <img
                alt='location type icon'
                src={`${
                  location.locationType === 'in_studio' || location.locationType === 'in_house'
                    ? dropPinIcon
                    : webcamIcon
                }`}
                width={18}
                height={21}
              />
            </div>
            <div className='location-title'>
              {location.locationTypeLabel}
              {location.locationType !== 'webcam' && ' :'}
            </div>
          </div>
          <div className='locations'>
            {location.locationType !== 'webcam' &&
              location.locations.map((location, index) => (
                <div key={index} className='location'>
                  <ul>
                    <li
                      className={`small-pin`}
                      onMouseEnter={() => setHoverLocation(location.id)}
                      onMouseLeave={() => setHoverLocation(null)}
                      onClick={() => onClick(location)}
                    >
                      {location.location}
                    </li>
                  </ul>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  )
})
